import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TextCustomFieldConfig, SharedModule, FormInputComponent, DataService } from '@vendure/admin-ui/core';

@Component({
    selector: 'vdr-available-months-form-conditional',
    templateUrl: './available-months-form-conditional.component.html',
    styleUrls: ['./available-months-form-conditional.component.scss'],
    standalone: true,
    imports: [SharedModule],
})
export class AvailableMonthsFormConditionalComponent implements FormInputComponent<TextCustomFieldConfig> {
    readonly: boolean;
    config: TextCustomFieldConfig;
    formControl: FormControl;

    defaultValues = {
        month: 'all',
        openingTime: '00:00',
        closingTime: '23:59',
        orderLimit: '', // Optional field for order limit
    };

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {
        if (this.formControl.value) {
            this.defaultValues = JSON.parse(this.formControl.value);
        } else {
            this.formControl.setValue(JSON.stringify(this.defaultValues));
        }
    }

    onValueChange(event: Event, type: 'month' | 'openingTime' | 'closingTime' | 'orderLimit') {
        const newValue = (event.target as HTMLInputElement).value;
        if (type === 'orderLimit') {
            this.defaultValues[type] = newValue ? newValue : ''; // Ensure orderLimit is a number or empty
        } else {
            this.defaultValues[type] = newValue;
        }
        this.formControl.setValue(JSON.stringify(this.defaultValues));
    }
}
